var InvoiceType;
(function (InvoiceType) {
  InvoiceType["unpaid"] = "UNPAID";
  InvoiceType["all"] = "ALL";
})(InvoiceType || (InvoiceType = {}));
export default InvoiceType;